import { Card, Typography } from 'antd'

const { Title } = Typography

interface Props {
  text: string
  opaque?: boolean
}

const Signature = ({ text, opaque = true }: Props) => (
  <Card
    styles={{ body: { padding: 10, textAlign: 'center' } }}
    style={{ opacity: opaque ? 1 : 0.2 }}
  >
    <Title className="sign-font">{text}</Title>
  </Card>
)

export default Signature
